<template>
  <div class="select-jump-type">
    <div class="input-box " :class="{ 'icon-type': type === 'icon' }">
      <p v-if="type === 'default' && showTitle">链接</p>
      <el-cascader
        v-model="selectValue"
        :options="options"
        :clearable="type !== 'icon'"
        :popper-class="type === 'icon' ? 'select-jump-link-popup' : ''"
        @change="change"
        @visible-change="visibleChange"
        ref="cascader"
        :props="{ expandTrigger: 'hover' }"
        :placeholder="type === 'icon' ? '' : '请选择跳转页面'"
      ></el-cascader>
    </div>

    <div class="additional-box" v-if="showAdditional">
      <p>{{ additionalLabel }}</p>
      <div>
        <CategorySelect
          v-if="this.selectValue[1] === 'shopType'"
          style="width: 100%;"
          :categoryId="additionalValue"
          :channelCodes="channelCodes"
          @changeCascader="val => (additionalValue = val)"
        >
        </CategorySelect>
        <el-input
          v-else
          v-model="additionalValue"
          :placeholder="placeholderText"
          @pointerdown.stop.native
        ></el-input>
        <el-button
          v-if="btnText"
          type="primary"
          @click="additionalHanderClick"
          >{{ btnText }}</el-button
        >
      </div>
    </div>

    <SelectProductDialog
      :isShowDialog="isShowDialog"
      @selectProductList="value => dialogConfirmCb(value, 'isShowDialog')"
      @closeShowDialog="dialogCloseCb('isShowDialog')"
    />

    <SelectAssemblyProductDialog
      :isShowDialog="isShowAssemblyDialog"
      @selectProductList="
        value => dialogConfirmCb(value, 'isShowAssemblyDialog')
      "
      @closeShowDialog="dialogCloseCb('isShowAssemblyDialog')"
    />

    <!-- 优惠券，用的时候改下交互 -->
    <!-- <SelectCouponDialog
      :couponListDialog="couponListDialog"
      @couponListSelect="couponListSelect"
      @closecCouponListDialog="dialogCloseCb('couponListDialog')"
    /> -->

    <FillInOtherLinkDialog
      :urlInputDialog="urlInputDialog"
      @inputValueSelect="value => dialogConfirmCb(value, 'urlInputDialog')"
      @closeurlInputDialog="dialogCloseCb('urlInputDialog')"
    ></FillInOtherLinkDialog>

    <FillInKeywordDialog
      :keywordInputDialog="keywordInputDialog"
      @keywordinputValueSelect="
        value => dialogConfirmCb(value, 'keywordInputDialog')
      "
      @closekeywordInputDialog="dialogCloseCb('keywordInputDialog')"
    ></FillInKeywordDialog>

    <FillInCategoryDialog
      :categoryDialog="categoryDialog"
      @closecategoryDialog="dialogCloseCb('categoryDialog')"
      @categoryValueSelect="value => dialogConfirmCb(value, 'categoryDialog')"
    ></FillInCategoryDialog>

    <SelectArticle
      v-if="showSelectArtice"
      v-model="showSelectArtice"
      :maxLength="1"
      @selected="value => dialogConfirmCb(value[0].articleId, 'showSelectArtice')"
    />

    <videoListSelect
      v-if="showSelectVideo"
      :limitNumber="1"
      :isShowDialog="showSelectVideo"
      @selectvideoList="value => dialogConfirmCb(value[0].videoId, 'showSelectVideo')"
      @closeShowDialog="dialogCloseCb('showSelectVideo')"
    >
    </videoListSelect>
  </div>
</template>

<script>
import SelectCouponDialog from "./SelectCouponDialog";
import FillInKeywordDialog from "./FillInKeywordDialog";
import SelectProductDialog from "./SelectProductDialog";
import FillInCategoryDialog from "./FillInCategoryDialog";
import FillInOtherLinkDialog from "./FillInOtherLinkDialog";
import SelectAssemblyProductDialog from "./SelectAssemblyProductDialog";
import videoListSelect from "@/myviews/shoppMall/popularscienceManage/rdvideoManage/components/videoListSelect";
import CategorySelect from "@/myviews/shoppMall/components/CategorySelect"; //分类
import SelectArticle from '@/myviews/shoppMall/popularscienceManage/components/SelectArticle'
import options from "./cascaderOptions";
export default {
  props: {
    showTitle: {
      type: Boolean,
      default: true
    },
    mode: {
      type: String,
      default: "default" // direct 直接选取, default 默认展示额外输入框选择
    },
    type: {
      type: String,
      default: "default"
    },
    path: {
      type: String,
      require: true
    }
  },
  components: {
    videoListSelect,
    SelectArticle,
    CategorySelect,
    SelectCouponDialog,
    SelectProductDialog,
    FillInKeywordDialog,
    FillInCategoryDialog,
    FillInOtherLinkDialog,
    SelectAssemblyProductDialog
  },
  watch: {
    path: {
      handler(val) {
        this.selectValue = val ? [val.split(",")[0], val.split(",")[1]] : [];
        const [_, type] = this.selectValue;
        if (this.mode === "default") {
          this.additionalLabel = {
            goodsItem: "商品ID",
            otherUrl: "其他链接",
            shopType: "商品分类",
            searchResultPage: "搜索词",
            assemblyGoods: "组合商品ID",
            article: "文章ID",
            video: "视频ID"
          }[type];
          this.placeholderText = {
            goodsItem: "请输入商品ID",
            otherUrl: "请输入其他跳转链接",
            shopType: "请输入商品分类ID",
            searchResultPage: "请输入搜索词",
            assemblyGoods: "请输入组合商品ID",
            article: "请输入文章ID",
            video: "请输入视频ID"
          }[type];
          this.btnText = {
            goodsItem: "选择商品",
            assemblyGoods: "选择组合商品",
            article: "选择文章",
            video: "选择视频"
          }[type];
          this.showAdditional = [
            "goodsItem",
            "otherUrl",
            "shopType",
            "searchResultPage",
            "assemblyGoods",
            "article",
            "video"
          ].includes(type);
        }
      },
      immediate: true
    }
  },
  computed: {
    selectType() {
      const [_, type] = this.selectValue;
      return type;
    },
    additionalValue: {
      get() {
        const pathArray = this.path.split(",");
        return pathArray[2] || "";
      },
      set(value) {
        const str = this.selectValue.join(",");
        const modelValue = `${str},${value}`;
        this.$emit("change", modelValue);
      }
    }
  },
  data() {
    return {
      channelCodes: ["SHOP"],
      selectedType: "",
      showAdditional: false,
      additionalLabel: "商品",
      placeholderText: "商品",
      btnText: "选择商品",
      selectValue: [],
      isShowDialog: false, // 普通商品弹窗bool值
      isShowAssemblyDialog: false, // 组合商品弹窗bool值
      selectedArticle: [],
      categoryDialog: false,
      urlInputDialog: false,
      couponListDialog: false,
      keywordInputDialog: false,
      showSelectArtice: false,
      showSelectVideo: false,
      options: Object.freeze(options),
      shopTypeOptions: [],
      shopTypeLoading: false
    };
  },
  methods: {
    visibleChange(flag) {
      this.$emit("visibleChange", flag);
    },
    closeDropDownVisible() {
      const cascader = this.$refs.cascader;
      cascader.toggleDropDownVisible(false);
    },
    additionalHanderClick() {
      const { selectedType, selectValue } = this;
      let type = selectedType;
      if (!selectedType && selectValue.length) {
        type = selectValue[selectValue.length - 1];
      }
      this.isShowDialog = type === "goodsItem";
      this.isShowAssemblyDialog = type === "assemblyGoods";
      this.showSelectArtice = type === "article";
      this.showSelectVideo = type === "video";
    },
    change(types) {
      const { mode } = this;
      const [, type] = types;
      this.selectedType = type;
      if (
        [
          "goodsItem",
          "otherUrl",
          "shopType",
          "searchResultPage",
          "assemblyGoods",
          "article",
          "video"
        ].includes(type) &&
        mode === "direct"
      ) {
        this.isShowDialog = type === "goodsItem";
        this.urlInputDialog = type === "otherUrl";
        this.categoryDialog = type === "shopType";
        this.keywordInputDialog = type === "searchResultPage";
        this.isShowAssemblyDialog = type === "assemblyGoods";
        this.showSelectArtice = type === "article";
        this.showSelectVideo = type === "video";
      } else {
        this.showAdditional = false;
        const str = this.selectValue.join(",");
        this.$emit("change", str);
      }
    },

    dialogCloseCb(visible) {
      if (this.type === "icon") {
        this.selectValue = [];
      }
      this[visible] = false;
    },

    dialogConfirmCb(value, visible) {
      const str = this.selectValue.join(",");
      const modelValue = `${str},${value}`;
      this.$emit("change", modelValue);
      this[visible] = false;
    }
  }
};
</script>

<style lang="less" scoped>
.select-jump-type {
  .input-box {
    flex: 1;
    display: flex;
    align-items: center;
    width: 100%;
    height: 30px;
    line-height: 30px;
    > p {
      font-size: 12px;
      font-weight: 400;
      margin-right: 10px;
      line-height: 30px;
      white-space: nowrap;
    }
    /deep/ .el-button {
      width: 44px;
      height: 30px;
      padding: 0;
      background: #2154f4;
      border-radius: 0;
      color: #fff;
      font-size: 12px;
      margin-left: 6px;
      margin-top: 2px;
    }
    /deep/ .el-cascader {
      flex: 1;
      color: #333;
      line-height: 30px;

      .el-input__inner {
        width: 100%;
        height: 30px;
        line-height: 30px;
        background: #ffffff;
        border: 1px solid #e5e5e5;
        border-radius: 0;
        padding: 0 10px;
        font-size: 12px;
      }
      .el-input__inner::placeholder {
        color: #999999;
      }
    }
  }
  .additional-box {
    margin-top: 10px;
    display: flex;
    align-items: center;
    > p {
      font-size: 12px;
      font-weight: 400;
      margin-right: 10px;
      line-height: 30px;
      white-space: nowrap;
    }
    > div {
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex: 1;
      /deep/ .el-button {
        height: 30px;
        line-height: 30px;
        font-size: 12px;
        padding: 0 5px;
        border-radius: 0;
        margin-left: 5px;
        background: #2154f4;
        border: none;
      }
      /deep/ .el-input {
        .el-input__inner {
          width: 100%;
          height: 30px;
          line-height: 30px;
          background: #ffffff;
          border: 1px solid #e5e5e5;
          border-radius: 0;
          padding: 0 10px;
          font-size: 12px;
        }
        .el-input__inner::placeholder {
          color: #999999;
        }
      }
    }
  }

  .icon-type {
    width: 25px;
    height: 25px;
    /deep/ .el-cascader {
      height: 25px;
      .el-input {
        background: #fff;
        height: 25px;
      }
      .el-input__inner {
        padding: 0;
        padding-right: 0;
        width: 25px;
        height: 25px;
        opacity: 0;
      }
      .el-input__suffix {
        right: 0px;
        top: -3px;
        .el-icon-arrow-down::before {
          content: "\E737";
          color: #333;
        }
        .el-input__icon {
          line-height: 25px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/components/SelectJumpLink.vue